import { createAsyncThunk } from '@reduxjs/toolkit';

import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

import { KhodroHttpGetService } from '../Services/KhodroHttpService';

export const getActiveTaahodSalesSarneshin = createAsyncThunk(
  'TaahodSalesSarneshin/GetActiveTaahodSalesSarneshin',
  async () => {
    return await KhodroHttpGetService({
      url: `${_apiPathManagerConfig?.Khodro.TaahodSalesSarneshin.GetActiveTaahodSalesSarneshin}`,
    });
  }
);
